module.exports = __webpack_public_path__ + "img/heart_6_bj.80b88842.png";